export default {
  applyToVersions: "<2.3.4",
  type: "before",
  name: "update effect amount strings",
  migrate(data) {
    if (data?.effects == null) return data;
    if (data?.gameRounds == null) return data;

    // migrate effects
    for (const effectId in data.effects.items) {
      const effect = data.effects.items[effectId];

      effect.amount = migrateEffectString(effect.amount + "");
      effect.amount = migrateEffectStringFunctions(effect.amount);
    }

    // migrate scheduledImpulses:
    for (const simulationId in data.gameRounds.items) {
      const rounds = data.gameRounds.items[simulationId];
      for (const round of rounds) {
        for (const scheduledImpulse of round.scheduledImpulses) {
          scheduledImpulse.amount = migrateEffectString(
            scheduledImpulse.amount + ""
          );
        }
      }
    }

    return data;
  }
};

function migrateEffectString(str) {
  if (str.includes("{")) return str;
  str = replaceString(str, /@([er][0-9]+)@/, "@{$1}");
  str = replaceString(str, /minvalue/, "${minvalue}");
  str = replaceString(str, /maxvalue/, "${maxvalue}");
  str = replaceString(str, /value/, "${value}");
  str = replaceString(str, /max_x/, "${maxvalue}");
  str = replaceString(str, /min_x/, "${minvalue}");
  str = replaceString(str, /x/, "${x}");
  str = replaceString(str, /t/, "${t}");
  return str;
}
function migrateEffectStringFunctions(str) {
  if (str.includes("#")) return str;
  str = replaceString(str, /round\(/, "#round(");
  str = replaceString(str, /min\(/, "#min(");
  str = replaceString(str, /max\(/, "#max(");
  str = replaceString(str, /randbetween\(/, "#randbetween(");
  str = replaceString(str, /abs\(/, "#abs(");
  str = replaceString(str, /sign\(/, "#sign(");
  str = replaceString(str, /mod\(/, "#mod(");
  return str;
}

/**
 * Replace all occurrences of a string in a string,
 * where the included string doesn't touch any other letters.
 * @param {String} str
 * @param {RegExp} regex
 * @param {String} replacement
 */
function replaceString(str, regex, replacement) {
  const regexpression = new RegExp(
    "(?<=[^a-z]|^)" + regex.source + "(?=[^a-z]|$)",
    "gi"
  );
  return str.replaceAll(regexpression, replacement);
}
